import React from "react";
import { createRoot } from 'react-dom/client';
import {MiniMapWidget} from "./components/minimapWidget/MiniMapWidget";
import {MiniMapRisksWidget} from "./components/minimapWidget/MiniMapRisksWidget";

export const mount = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<MiniMapWidget {...props} />);
}

export const mountRisks = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<MiniMapRisksWidget {...props} />);
}